import { useNode } from "@craftjs/core";
import React, { useState } from "react";

import {
  CenterAlignActiveIcon,
  CenterAlignIcon,
  JustifyActiveIcon,
  JustifyIcon,
  LeftALignActiveIcon,
  LeftALignIcon,
  RightAlignActiveIcon,
  RightAlignIcon,
  UpperCaseIcon,
  TitleCaseIcon,
  LowerCaseIcon,
  TextActiveIcon,
  PencilActiveIcon,
  PaintIcon,
  SettingsIcon,
} from "../../../assets/ui-icons";
import {
  ColorInput,
  CountSliderInput,
  OptionsInput,
  MarginInput,
  PaddingInput,
  Panel,
  RangeInput,
  SelectInput,
  SpacerInput,
  FormatOptionsInput,
  Tabs,
} from "./../../ui-kit";
import RightBar from "../../ui-kit/rightbar";
import { isUpdatedFromDefault } from "../../utils";
import { IconPack } from "../../../assets/icon-pack";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSTextSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
  }));

  const [isActive, setIsActive] = useState("general");

  const {
    structureTag = "p",
    layoutColumns,
    layoutColumnsGap,
    align,
    textColor,
    backgroundColor,
    linkColor,
    typoSize = 16,
    typoLineHeight,
    typoWordSpacing,
    typoTransform,
    typoStyle,
    typoWeight,
    layoutPadding,
    layoutMargin,
  } = props;

  const General = () => {
    return (
      <>
        <SpacerInput>
          <SelectInput
            label="Tag"
            resetValue="p"
            value={structureTag}
            onChange={(val) => {
              setProp((props) => {
                props.structureTag = val;
                props.typoSize = undefined;
              });
            }}
            options={[
              {
                label: "Paragraph",
                value: "p",
                component: <p>Paragraph</p>,
              },
              {
                label: "Heading 1",
                value: "h1",
                component: <h1 className="text-4xl font-bold">Heading 1</h1>,
              },
              {
                label: "Heading 2",
                value: "h2",
                component: <h2 className="text-3xl font-[600]">Heading 2</h2>,
              },
              {
                label: "Heading 3",
                value: "h3",
                component: <h3 className="text-2xl font-[400]">Heading 3</h3>,
              },
              {
                label: "Heading 4",
                value: "h4",
                component: <h4 className="text-xl font-[300]">Heading 4</h4>,
              },
              {
                label: "Heading 5",
                value: "h5",
                component: <h5 className="text-lg font-[300]">Heading 5</h5>,
              },
              {
                label: "Heading 6",
                value: "h6",
                component: <h6 className="text-base font-[300]">Heading 6</h6>,
              },
            ]}
          />
          <FormatOptionsInput label={"Font Style"} />
          <RangeInput
            resetValue={16}
            // min={5}
            min={INPUT_LIMITS["cms-font-size"].min}
            max={INPUT_LIMITS["cms-font-size"].max}
            step={INPUT_LIMITS["cms-font-size"].step}
            label="Font Size"
            value={typoSize}
            onChange={(val) => {
              setProp((props) => {
                props.typoSize = val + "px";
              });
            }}
          />
          <OptionsInput
            label={"Alignment"}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            options={[
              {
                label: "Justify",
                value: "justify",
                icon: <JustifyIcon width={"20px"} />,
                active: <JustifyActiveIcon width={"20px"} />,
              },
              {
                label: "Left",
                value: "left",
                icon: <LeftALignIcon width={"20px"} />,
                active: <LeftALignActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <CenterAlignIcon width={"20px"} />,
                active: <CenterAlignActiveIcon width={"20px"} />,
              },
              {
                label: "Right",
                value: "right",
                icon: <RightAlignIcon width={"20px"} />,
                active: <RightAlignActiveIcon width={"20px"} />,
              },
            ]}
          />
        </SpacerInput>
        <div className="bg-white mt-4 py-2 rounded-[21px] ">
          <Panel label={"More"}>
            <SpacerInput>
              <SelectInput
                resetValue={undefined}
                value={typoWeight}
                onChange={(val) => {
                  setProp((props) => {
                    props.typoWeight = val;
                  });
                }}
                options={[
                  {
                    label: "Bold",
                    value: "600",
                    component: <p className="font-[600]">Bold</p>,
                  },
                  {
                    label: "Semibold",
                    value: "500",
                    component: <p className="font-[500]">Semibold</p>,
                  },
                  {
                    label: "Regular",
                    value: "400",
                    component: <p className="font-[400]">Regular</p>,
                  },
                  {
                    label: "Light",
                    value: "300",
                    component: <p className="font-[300]">Light</p>,
                  },
                ]}
                label={"Font Weight"}
              />

              {/* <div className="flex gap-[10px]">
                <div
                  title="Line Height"
                  className="flex-1 bg-ui-light-white py-2 px-5 pr-4 gap-3 rounded-full flex items-center "
                >
                  <div>
                    <LineHeightIcon />
                  </div>
                  <div className="flex-1">
                    <input
                      type="number"
                      min={0}
                      max={10}
                      value={typoLineHeight}
                      onChange={(e) => {
                        setProp((props) => {
                          props.typoLineHeight = e.target.value;
                        });
                      }}
                      className="outline-none  bg-transparent w-full text-center"
                    />
                  </div>
                </div>
                <div
                  title="Letter Spacing"
                  className="flex-1 bg-ui-light-white py-2 px-5 pr-4 gap-3 rounded-full flex items-center"
                >
                  <div>
                    <LetterSpacingIcon />
                  </div>
                  <div className="flex-1">
                    <input
                      min={0}
                      max={10}
                      value={typoWordSpacing}
                      onChange={(e) => {
                        setProp((props) => {
                          props.typoWordSpacing = e.target.value;
                        });
                      }}
                      type="number"
                      className="outline-none bg-transparent w-full text-center"
                    />
                  </div>
                </div>
              </div> */}
              <OptionsInput
                label={"Transform"}
                value={typoTransform}
                onChange={(val) => {
                  setProp((props) => {
                    props.typoTransform = val;
                  });
                }}
                options={[
                  {
                    label: "Uppercase",
                    value: "Uppercase",
                    icon: <UpperCaseIcon />,
                    active: (
                      <UpperCaseIcon className="text-white fill-current" />
                    ),
                  },
                  {
                    label: "Capitalize",
                    value: "Capitalize",
                    icon: <TitleCaseIcon />,
                    active: (
                      <TitleCaseIcon className="text-white fill-current" />
                    ),
                  },
                  {
                    label: "Lowercase",
                    value: "Lowercase",
                    icon: <LowerCaseIcon />,
                    active: (
                      <LowerCaseIcon className="text-white fill-current" />
                    ),
                  },
                ]}
              />
            </SpacerInput>
          </Panel>
        </div>
      </>
    );
  };

  const Styles = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Colors"} isOpen={true}>
          <SpacerInput>
            <ColorInput
              value={textColor}
              onChange={(val) => {
                setProp((props) => {
                  props.textColor = val;
                });
              }}
              label={"Text"}
              useTextColorPalette={true}
              supportSelection={true}
            />
            <ColorInput
              value={backgroundColor}
              onChange={(val) => {
                setProp((props) => {
                  props.backgroundColor = val;
                  if (!props.layoutPadding) {
                    props.layoutPadding = {
                      top: "20px",
                      right: "35px",
                      bottom: "20px",
                      left: "35px",
                    };
                  }
                  if (
                    !val &&
                    props.layoutPadding &&
                    props.layoutPadding.top === "20px" &&
                    props.layoutPadding.right === "35px" &&
                    props.layoutPadding.bottom === "20px" &&
                    props.layoutPadding.left === "35px"
                  ) {
                    props.layoutPadding = undefined;
                  }
                });
              }}
              label={"Background"}
            />
            <ColorInput
              value={linkColor}
              onChange={(val) => {
                setProp((props) => {
                  props.linkColor = val;
                });
              }}
              label={"Link"}
              useTextColorPalette={true}
              supportSelection={true}
            />
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const Advance = () => {
    return (
      <>
        <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
          <Panel label={"Layout"} isOpen={true}>
            <SpacerInput>
              <PaddingInput
                value={layoutPadding}
                onChange={(val) => {
                  setProp((props) => {
                    props.layoutPadding = val;
                  });
                }}
              />
              <MarginInput
                value={layoutMargin}
                onChange={(val) => {
                  setProp((props) => {
                    props.layoutMargin = val;
                  });
                }}
              />
            </SpacerInput>
          </Panel>
        </div>
        <div className="w-full mt-4 rounded-[21px] py-2 bg-white flex flex-col">
          <Panel label={"Columns"} isOpen={true}>
            <SpacerInput>
              <CountSliderInput
                resetValue={0}
                label="Columns Count"
                value={layoutColumns}
                onChange={(val) => {
                  setProp((props) => {
                    props.layoutColumns = val;
                  });
                }}
                min={2}
                max={8}
                step={1}
              />
              <CountSliderInput
                resetValue={0}
                label="Columns Gap"
                value={layoutColumnsGap}
                onChange={(val) => {
                  setProp((props) => {
                    props.layoutColumnsGap = val + "px";
                  });
                }}
              />
            </SpacerInput>
          </Panel>
        </div>
      </>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Advanced",
      key: "advanced",
      icon: IconPack.Settings,
      children: Advance(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar cursor-default p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar title={"Text"} icon={<TextActiveIcon />} />
        </div>
        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />
        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
